import { db } from 'codemash';
import { Config } from '../configs';
import { mapDeliverySettings, mapDeliveryRestaurants } from './mappers/delivery';
import { manageApiUnavailableError } from './error/errors';

export const getComapnyRestaurantsBySlug = async ({ companySlug }) => {
  try {
    if (!companySlug) {
      return {};
    }

    const response = await db.executeAggregate({
      id: Config.DATA.AGGREGATES.GET_COMPANY_RESTAURANTS_BY_SLUG_V2,
      collectionName: Config.DATA.COLLECTIONS.DELIVERY_SETTINGS,
      database: Config.CODEMASH.DB_STORAGE_ID,
      tokens: {
        slug: companySlug,
      },
    });

    if (response && response.length > 0) {
      return {
        deliverySettings: mapDeliverySettings({ settings: response[0].delivery_settings }),
        restaurants: mapDeliveryRestaurants({ restaurants: response[0].restaurants }),
      };
    }
  } catch (e) {
    manageApiUnavailableError(e);

    if (Config.SHOW_LOGS) {
      console.log('Error while trying to get table by qr code', e);
    }
  }

  return {};
};
